import ReactECharts from "echarts-for-react";
import type { EChartsOption } from "echarts";

// Internal wrapper so panels never import echarts-for-react directly. Lets us
// swap to the core/tree-shaken echarts import, add theming, or change the
// renderer later in one place.
interface ChartProps {
  option: EChartsOption;
  height?: number;
  // optional ECharts event handlers, e.g. { legendselectchanged: (e) => ... }
  onEvents?: Record<string, (params: any) => void>;
}

export function Chart({ option, height = 320, onEvents }: ChartProps) {
  return (
    <ReactECharts
      option={option}
      style={{ height, width: "100%" }}
      notMerge
      lazyUpdate
      onEvents={onEvents}
    />
  );
}
